import { useQuery } from 'react-query';

import { getSurgicalPhasesList } from '../api/getSurgicalPhasesList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

export const useSurgicalPhasesList = ({ enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.surgicalPhases(),
    ({ signal }) => getSurgicalPhasesList(signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useSurgicalPhasesList;
